/* global $ */
let ticking = false
let isFixedHeaderShowing = false

export function conditionalAddStaticHeader(divId) {
    if (isFixedHeaderShowing) {
        // I can't get this to work without a flicker
        $(`#${divId} table thead`).removeClass('fixed-header')
        $(`#${divId} th`).css('width', 'auto')
        $(`#${divId} td`).css('width', 'auto')
        // Ick
        setTimeout(() => {
            addStaticHeader(divId)
        }, 0)
    }
}

function addStaticHeader(divId) {
    const width = $(`#${divId}`).outerWidth()

    if (width && width > 767) {
        // Set TH Width before applying fixed-header
        const widths = $(`#${divId} .default-table-row`)
            .first()
            .children('td')
            .each(function eachHandler(i) {
                const $this = $(this)
                const rowWidth = $this.outerWidth()
                $this
                    .closest('tbody')
                    .prev('thead')
                    .find(`tr.tr-component-row > th:nth-child(${i + 1})`)
                    .css('width', rowWidth)
            })
            .map(function handleMap() {
                return $(this).outerWidth()
            })

        // Set TD Width before applying fixed-header
        $(`#${divId} > table > thead > .tr-component-row`)
            .children('th')
            .each(function eachHandler(i) {
                const $this = $(this)
                const rowWidth = widths[i]

                $this
                    .closest('thead')
                    .next('tbody')
                    .find(`> .default-table-row td:nth-child(${i + 1})`)
                    .css('width', rowWidth)
            })

        $(`#${divId} > table > thead`).addClass('fixed-header')
    }
}
// FIXED SCROLL?
function checkHeaderPosition(divId) {
    const scrollPosY = window.scrollY
    const posTop = $(`#${divId}`).offset().top
    const height = $(`#${divId} table thead`).height()
    if (!isFixedHeaderShowing && posTop < scrollPosY) {
        isFixedHeaderShowing = true
        addStaticHeader(divId)
    } else if (isFixedHeaderShowing && posTop - height > scrollPosY) {
        $(`#${divId} table thead`).removeClass('fixed-header')
        isFixedHeaderShowing = false
    }
}

export default function init(tableDivId, data) {
    window.addEventListener('scroll', () => {
        if (!ticking && data.length) {
            window.requestAnimationFrame(() => {
                checkHeaderPosition(tableDivId)
                ticking = false
            })

            ticking = true
        }
    })

    window.addEventListener('resize', () => {
        if (isFixedHeaderShowing) {
            addStaticHeader(tableDivId)
        }
    })
}
